import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Icons } from "../../constants/icon-library";

const RegenerateModal = ({ show, onHide, onConfirm, meeting }) => {
  if (!show) return null;

  const validationSchema = Yup.object({
    prompt: Yup.string()
      .trim()
      .required("Prompt is required")
      .min(3, "Prompt must be at least 3 characters"),
  });

  const initialValues = {
    prompt: "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await onConfirm?.(values.prompt, meeting);
      resetForm();
      onHide?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="modal-backdrop fade show"
        onClick={onHide}
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      />

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content bg-body-highlight p-6 border-0 shadow-lg">
            <div className="modal-header justify-content-between border-0 p-0 mb-2">
              <div className="row d-flex mb-2">
                <div className="justify-content-start ">
                  <h3 className="mb-0 d-flex align-items-center">
                    <i className={`wb ${Icons("rework")} me-2`} />
                    Regenerate Task
                  </h3>
                </div>
              </div>
              <div className="justify-content-end">
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onHide}
                />
              </div>
            </div>

            <div className="card p-3 mb-1">
              <h5 className="mb-3">💡 Suggested Prompts</h5>

              <ul className="list-unstyled">
                <li className="mb-2">
                  <strong>Remove tasks related to a person:</strong> Filter out
                  tasks assigned to specific individuals.
                </li>
                <li className="mb-2">
                  <strong>Keep only tasks related to a platform:</strong> Focus
                  on tasks involving specific platforms.
                </li>
                <li className="mb-2">
                  <strong>Give Custom Command:</strong> Give Command  what type of task you want form meeting summary.
                </li>
              </ul>
            </div>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="modal-body px-0">
                    <div className="form-floating">
                      <Field
                        id="prompt"
                        name="prompt"
                        as="textarea"
                        className="form-control"
                        placeholder="Enter Your Prompt"
                        style={{ height: "200px" }}
                      />
                      <label htmlFor="prompt"></label>
                    </div>

                    <ErrorMessage
                      name="prompt"
                      component="div"
                      className="text-danger fs-9 mt-2"
                    />
                  </div>

                  <div className="modal-footer border-0 px-0 pb-0 d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
                      onClick={onHide}
                      disabled={isSubmitting}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                      disabled={isSubmitting}
                    >
                      <i className={`wb ${Icons("repeat")} me-2`} />
                      {isSubmitting ? "Regenerating..." : "Regenerate"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegenerateModal;
